// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import {
  Card,
  SvgIcon
} from '../../'

import { PayslipEngagementStats } from './PayslipEngagementStats'
  import { MonthlyBillingStats } from './MonthlyBillingStats'

import { hasResponsibility } from '../../../utils'


export class Reporting extends Component {
  static propTypes = {
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    showPayslipEngagementStats: false
  }

  toggleShowPayslipEngagementStats = (e) => {
    this.setState(prevState => (
      { showPayslipEngagementStats: !prevState.showPayslipEngagementStats }
    ))
  }

  toggleShowMonthlyBillingStats = (e) => {
    this.setState(prevState => (
      { showMonthlyBillingStats: !prevState.showMonthlyBillingStats }
    ))
  }

  render() {
    const hasPayslipUploadPermission = hasResponsibility('self','messageplus_payslip_upload')
    const hasBillingGenerationPermission = hasResponsibility('self','messageplus_billing_generate')

    return (
      <Card
        title='Reporting'
        icon={
          <SvgIcon
            variant='utility'
            symbol='cases'
            size='medium'
          />
        }
        info={null}
        body={
          <div className='slds-p-bottom_medium u-font-size-larger'>
            {!this.props.isEmployerGroupAccount && (
                hasPayslipUploadPermission || hasBillingGenerationPermission
              )
              ? <Fragment>
                  {hasPayslipUploadPermission &&
                    <PayslipEngagementStats
                      show={this.state.showPayslipEngagementStats}
                      toggleShow={this.toggleShowPayslipEngagementStats}
                      style={{ borderBottom: '2px solid lavender' }}
                    />
                  }
                  {hasBillingGenerationPermission &&
                    <MonthlyBillingStats
                      show={this.state.showMonthlyBillingStats}
                      toggleShow={this.toggleShowMonthlyBillingStats}
                      style={{ borderBottom: '2px solid lavender' }}
                    />
                  }
                </Fragment>
              : 'No options available under current account'
            }
          </div>
        }
        footer={null}
        yScrollable={true}
        paddingTRL={true}
        className={this.props.className}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/dashboard-reporting/index.js